"use strict";
ui.loadTemplateFile("options.html");

const MOVEMENT_MODES = ["traditional", "modern"];

class OptionsDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _musicSlider: any;
    _movementMode: any;
    _options: any;

    constructor(options: any) {
        super("options.html");

        this.center();

        ui.tabpanel(this, ".tabpanel.category");

        this._musicSlider = ui.slider(this, ".slider");
        this._musicSlider.on("change", this._onMusicChange.bind(this));

        this._movementMode = ui.radiogroup(this, ".radiogroup.movement-mode");
        this._movementMode.on("itemclicked", this._onMovementModeChange.bind(this));

        this._options = options;
        this._options.on("changed", this._update.bind(this));
        this._update(this._options);
    }

    _update(options: any) {
        if (this._musicSlider) {
            this._musicSlider.value(options.options.musicVolumePercentage);
        }
        if (this._movementMode) {
            this._movementMode.index(MOVEMENT_MODES.indexOf(options.options.movementMode), true);
        }
    }

    _onMusicChange() {
        let value = parseInt(this._musicSlider.value());
        this._options.set("musicVolumePercentage", value);
    }

    _onMovementModeChange(index: any) {
        this._options.set("movementMode", MOVEMENT_MODES[index]);
    }
}

ui.OptionsDialog = OptionsDialog;

// Helper widget for stats
class OptionStat extends Widget {
    _element: any;
    _value: any;
    _bar: any;
    _units: string;
    _cost: any;
    _levelup: any;

    constructor(element: any) {
        super(element);

        this._value = ui.label(this, ".label.value");
        this._bar = ui.progressbar(this, ".progressbar.value");
        this._units = "";

        this._cost = ui.label(this, ".label.cost");
        this._levelup = ui.button(this, ".button.levelup");

        if (this._cost) {
            this._cost.hide();
        }

        if (this._levelup) {
            this._levelup.hide();
        }
    }

    unit(unit: any) {
        if (unit === undefined) {
            return this._units;
        } else {
            this._units = unit;
        }
    }

    value(value: any) {
        if (value === undefined) {
            if (this._value) {
                return this._value.text().replace(this._units, "");
            } else if (this._bar) {
                return this._bar.value();
            }
        } else if (this._value) {
            this._value.text(value + this._units);
        } else if (this._bar) {
            this._bar.value(value);
        }
    }

    min(min: any) {
        if (this._bar) {
            return this._bar.min(min);
        }
    }

    max(max: any) {
        if (this._bar) {
            return this._bar.max(max);
        }
    }
}

ui.OptionStat = OptionStat;

ui.optionstat = ui.widgetConstructor("option", ui.OptionStat);

ui.optionsDialog = function (options: any) {
    return new ui.OptionsDialog(options);
};
